import React, { PureComponent } from 'react';
import { Col, Form } from 'react-bootstrap';
import { Shapes } from '../../../models/entities';

class PersistentValuesReportForm extends PureComponent {
  constructor(props) {
    super(props);

    const { bptHealthReport } = props;
    if (bptHealthReport) {
      this.state = { ...bptHealthReport.persistentValuesReport };
    } else {
      this.state = {
        transactionNumber: undefined,
        failedBillScanCount: undefined,
        rejectedCashCount: undefined,
        failedCheckScanCount: undefined,
        cashAcceptorBillCount: undefined,
        audioVolume: undefined,
        transactionCount: undefined,
        transactionTotal: undefined,
        checkCount: undefined,
        checkTotal: undefined,
        creditCount: undefined,
        creditTotal: undefined,
        cash1Count: undefined,
        cash5Count: undefined,
        cash10Count: undefined,
        cash20Count: undefined,
        cash50Count: undefined,
        cash100Count: undefined,
        cashCount: undefined,
        cashTotal: undefined,
      };
    }
  }

  render = () => {
    const {
      transactionNumber, failedBillScanCount, rejectedCashCount, failedCheckScanCount,
      cashAcceptorBillCount, audioVolume, transactionCount, transactionTotal,
      checkCount, checkTotal, creditCount, creditTotal, cash1Count,
      cash5Count, cash10Count, cash20Count, cash50Count, cash100Count,
      cashCount, cashTotal,
    } = this.state;

    return (
      <Form noValidate>
        <Form.Row>
          <Col>
            <Form.Group controlId="transactionNumber">
              <Form.Label>Transaction Number</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={transactionNumber || '-'}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="failedBillScanCount">
              <Form.Label>Failed Bill Scan Count</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={failedBillScanCount || '-'}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="rejectedCashCount">
              <Form.Label>Rejected Cash Count</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={rejectedCashCount || '-'}
              />
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="failedCheckScanCount">
              <Form.Label>Failed Check Scan Count</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={failedCheckScanCount || '-'}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="cashAcceptorBillCount">
              <Form.Label>Cash Acceptor Bill Count</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={cashAcceptorBillCount || '-'}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="audioVolume">
              <Form.Label>Audio Volume</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={audioVolume || '-'}
              />
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="transactionCount">
              <Form.Label>Transaction Count</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={transactionCount || '-'}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="transactionTotal">
              <Form.Label>Transaction Total</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={transactionTotal || '-'}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="checkCount">
              <Form.Label>Check Count</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={checkCount || '-'}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="checkTotal">
              <Form.Label>Check Total</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={checkTotal || '-'}
              />
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="creditCount">
              <Form.Label>Credit Count</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={creditCount || '-'}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="creditTotal">
              <Form.Label>Credit Total</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={creditTotal || '-'}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="cash1Count">
              <Form.Label>Cash 1 Count</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={cash1Count || '-'}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="cash5Count">
              <Form.Label>Cash 5 Count</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={cash5Count || '-'}
              />
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="cash10Count">
              <Form.Label>Cash 10 Count</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={cash10Count || '-'}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="cash20Count">
              <Form.Label>Cash 20 Total</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={cash20Count || '-'}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="cash50Count">
              <Form.Label>Cash 50 Count</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={cash50Count || '-'}
              />
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="cash100Count">
              <Form.Label>Cash 100 Count</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={cash100Count || '-'}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="cashCount">
              <Form.Label>Cash Count</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={cashCount || '-'}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="cashTotal">
              <Form.Label>Cash Total</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={cashTotal || '-'}
              />
            </Form.Group>
          </Col>
        </Form.Row>
      </Form>
    );
  }
}

PersistentValuesReportForm.propTypes = {
  bptHealthReport: Shapes.BPT_HEALTH_REPORT,
};

PersistentValuesReportForm.defaultProps = {
  bptHealthReport: null,
};

export default PersistentValuesReportForm;
